module.exports = __webpack_public_path__ + "d642f94043657c8e72ae5885353d8825.mp4";